/*
Purpose: Route guard that only renders its children if the logged-in centre has a
         given accessible service enabled. Used to gate optional features (e.g. the
         booking/slot tool) without modifying the feature's own component.
Project: TCMS

Behaviour:
  - while the centre's service list is loading  -> lightweight placeholder
  - service present                             -> render the wrapped component
  - service absent / lookup failed              -> redirect (fail closed)

To switch from a redirect to an inline "not available" message later, replace the
<Navigate> below with the message markup. The redirect target is a single edit.
*/

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useServiceAccess } from '../serviceAccess';

const RequireService = ({ service, children }) => {
    const { services, hasService } = useServiceAccess();

    // Access list not resolved yet (initial load / refresh / direct URL).
    if (services === null) {
        return <div className="p-4">Loading…</div>;
    }

    if (!hasService(service)) {
        return <Navigate to="/calendar" replace />;
    }

    return children;
};

export default RequireService;
